import { dateService } from '@/core/services/date'
import { currencyResolver } from '@/features/currencies/resolvers/currency.resolver'
import { CreateTripResponse } from '../types/api-responses/create-trip-response'
import { CreatedTripModel } from '../types/models/created-trip.model'

export function createdTripResolver(res: CreateTripResponse): CreatedTripModel {
  return {
    id: res.id,
    slug: res.slug,
    date: dateService.toDate(res.date),
    time: dateService.timeToDate(res.time),
    expectedTimeOfArrival: res.expected_time_of_arrival,
    arrivalDuration: res.arrival_duration,
    fromPointLat: parseFloat(res.from_point_lat),
    fromPointLong: parseFloat(res.from_point_long),
    toPointLat: parseFloat(res.to_point_lat),
    toPointLong: parseFloat(res.to_point_long),
    fromPointName: res.from_point_name,
    toPointName: res.to_point_name,
    flightNumber: res.flight_number,
    isPaid: res.is_paid,
    status: {
      id: res.status.id,
      name: res.status.name,
      key: res.status.key,
      color: res.status.color,
      icon: res.status.icon,
    },
    subStatus: res.sub_status,
    passengers: res.passengers,
    luggage: res.luggage,
    vehicleClass: res.vehicle_class,
    vehicleSize: res.vehicle_size,

    extraVehicle: res.extraVehicle,
    driver: res.driver,
    vehicle: res.vehicle,
    tripKilo: res.trip_kilo,
    totalPrice: res.total_price,
    meetingPointName: res.meeting_point_name,
    meetingPointImages: res.meeting_point_images,
    meetingPointLat: res.meeting_point_lat,
    meetingPointLong: res.meeting_point_long,
    createdAt: res.created_at,
    price: parseFloat(res.price),
    customerPrice: parseFloat(res.customer_price || ''),
    providerPrice: parseFloat(res.provider_price || ''),
    discount: parseFloat(res.discount),
    downloadAt: res.download_at,
    business: res.business,
    tripType: res.trip_type,
    review: res.review,
    cancellation: res.cancellation,
    refund: res.refund,
    note: res.note,
    currency: currencyResolver([res.currency])[0],
  }
}
